"use client";

import * as React from "react";
import { useState } from "react";
import { CalendarIcon } from "@radix-ui/react-icons";
import { format } from "date-fns";

import { cn } from "../../lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../popover/Popover";
import { Button } from "../button/Button";
import { Calendar } from "./Calendar";
import { es } from "date-fns/locale";

export function DatePicker({ onValueChange, defaultValue = null }) {
  const [date, setDate] = React.useState(defaultValue);
  const [shownMonth, setShownMonth] = React.useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  const onValueChangeHandler = (value) => {
    setDate(value);
    onValueChange(value);
    setIsOpen(false);
  };

  const handleMonthChange = (month) => {
    setShownMonth(month);
  };

  // date selection before 2/7/2023 as there is no api data prior to this date.
  const datesDisabled = {
    before: new Date(2023, 7, 2),
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[240px] justify-start text-left font-normal",
            !date && "text-muted-foreground",
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? (
            format(date, "PPP", { locale: es })
          ) : (
            <span>Seleccione una fecha</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={onValueChangeHandler}
          onMonthChange={handleMonthChange}
          month={shownMonth}
          initialFocus
          disabled={datesDisabled}
        />
      </PopoverContent>
    </Popover>
  );
}
